<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>模版列表</b></p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="openDialog" type="primary">新增模版</el-button>
                <span>-</span>
            </p>

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                    <el-button round type="primary">批量导e</el-button>
                    <span>-</span>
                </el-upload>
            </p> -->

        </div>

        <el-table :data="tmplList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="tmplTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column prop="tmplName" label="模版名称" min-width="20%">
            </el-table-column>
            <el-table-column prop="fileName" label="文件名" min-width="20%">
            </el-table-column>

            <el-table-column prop="createdTime" label="创建日期" min-width="14%">
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="10%">
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="20%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="bindClick(scope.row)" type="success" round size="small">
                        绑定公司
                    </el-button>
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        编辑
                    </el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                        删除
                    </el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <!-- <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div> -->

        <el-dialog title="模版详情" :visible.sync="dlgFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                <el-form-item label="模版名称" required :label-width="formLabelWidth">
                    <el-input v-model="form.tmplName" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>

                <el-form-item label="文件名" required :label-width="formLabelWidth">
                    <el-input v-model="form.fileName" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addPrintTmpl('ruleForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="公司绑定" :visible.sync="dlgTableVisible">
            <el-table :data="companyList">
                <el-table-column property="companyName" label="公司名称" width="360"></el-table-column>

                <el-table-column property="tmplName" label="模版" width="260"></el-table-column>

                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="bindOrNoClick(scope.row)" type="text" size="small" style="color:green">{{
                    scope.row.tmplCompanyId == null ? '绑定' : '取消绑定'
                            }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "TmplAdmin",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            tmplList: [],

            dlgFormVisible: false,
            dlgTableVisible: false,

            form: {
                id: '',
                tmplName: '',
                fileName: '',

                createdTime: new Date(),

                status: 0,
                remark: ''
            },

            companyList: [],
            formLabelWidth: '120px'
        }
    },
    methods: {
        selectClick(selection, row) {
            this.rowClick(row)
        },
        rowClick(row) {
            this.$refs.tmplTable.clearSelection()
            this.$refs.tmplTable.toggleRowSelection(row)
        },
        openDialog() {
            this.form.id = ''

            this.form.tmplName = ''
            this.form.fileName = ''

            this.form.createdTime = new Date()

            this.form.status = 1
            this.form.remark = ''

            this.dlgFormVisible = true
        },
        bindOrNoClick(row) {
            if (row.tmplCompanyId == null) {
                this.bindComp(row)
            } else {
                this.unBindEmp(row)
            }
        },
        bindComp(row) {
            this.$axios({
                method: "post",
                url: "/shiro/print/tmpl/company/bind",
                data: {
                    id: this.form.tmplId,
                    companyId: row.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.getAllTmplComp()
            })
        },
        bindClick(row) {
            this.form.tmplId = row.id
            this.dlgTableVisible = true

            this.getAllTmplComp()
        },
        getAllTmplComp() {
            this.$axios({
                method: "post",
                url: "/shiro/print/tmpl/company/tmplId",
                data: {
                    id: this.form.tmplId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.companyList = data.data
            })
        },
        handleClick(row) {
            // console.log(row)

            this.form.id = row.id

            this.form.tmplName = row.tmplName
            this.form.fileName = row.fileName

            this.form.createdTime = row.createdTime

            this.form.status = null
            this.form.remark = row.remark

            this.dlgFormVisible = true
        },
        addPrintTmpl(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    this.$axios({
                        method: "post",
                        url: "/shiro/print/tmpl/add",
                        data: {
                            id: this.form.id,
                            tmplName: this.form.tmplName,
                            fileName: this.form.fileName,
                            remark: this.form.remark
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        this.$message(data.msg)

                        this.dlgFormVisible = false

                        this.getAll()
                    })
                } else {
                    return false
                }
            })

        },
        getAll() {

            this.$axios({
                method: "post",
                url: "/shiro/print/tmpl/getAll",
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 400 || data.status == 401) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })

                    this.$router.push({ path: "/Login" })
                }

                this.tmplList = data.data

                for (let i in this.tmplList) {

                    this.tmplList[i].createdTime = this.$moment(this.tmplList[i].createdTime).format("YYYY-MM-DD")

                    if (this.tmplList[i].status == 0) {
                        this.tmplList[i].status = '禁用'
                    } else if (this.tmplList[i].status == 1) {
                        this.tmplList[i].status = '启用'
                    }
                }

            })
        },
        uploadFile(f) {

            const form = new FormData()

            form.append('uploadFile', f.file)

            this.$axios({
                method: "post",
                url: "/shiro/email/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data
            })
        }
    },
    mounted() {

        this.getAll()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>